import ApiCall from "./api-call";
// import EnvironmentEvo from "../../components/dataProviderEvo/environmentEvo";
import EnvironmentEvo from "../environmentEvo";
import config from "../../../config";
import Cookies from 'js-cookie';

export const API_URL_LOGIN =
    "/api/json/user/login";

export const API_URL_LOGOUT =
    "/api/json/user/logout";


export const API_URL_SIGNED =
    "/api/json/user/signed";

export const API_URL_REGISTER =
    "/api/json/user/registration";

export const API_URL_PASSWORD_CHANGE =
    "/api/json/user/password/change";

export const API_URL_PASSWORD_RESET =
    "/api/json/user/password/reset";


export const API_URL_REGISTER_CONFIRMATION =
    "/api/json/user/registration/confirmation";

export const API_URL_PURCHASE =
    "/api/json/subscription/make-order";

export const API_URL_PAYMENT_OPTIONS =
    "/api/json/cis/payment-method";

export const API_URL_SUBSCRIPTION_OPTIONS =
    "/api/json/cis/subscription-type";

/* issue lists */
export const API_URL_ISSUES =
    "/api/json/issue/list";


export const API_URL_PUBLIC_ISSUES =
    "/api/json/issue/list/public";

/* issue lists end */


export const API_URL_SUBSCRIPTION_CODE_PART =
    "/api/json/subscription-code";

export const API_URL_SUBSCRIPTION_CODE_ACTIVATION =
    "/api/json/subscription/activate-code";


export const API_URL_ISSUE_DETAIL_PART =
    "/api/json/issue";

export const API_URL_ORDER_DETAIL_PART =
    "/api/json/subscription/order";

/* public detail */

export const API_URL_ISSUE_PUBLIC_DETAIL =
    "/api/json/issue/get-main/detail";

/* public detail end */

/* user */
export const API_URL_USER_PART =
    "/api/json/user";

export const API_URL_USER_EMAIL_CHECK =
    "/api/json/user/email/check";


const API_AUTH_USERNAME = "evo-134ye6";
const API_AUTH_PASSWORD = "e26e3y6em81Fz&a4i7x";


/* user end */
//
// const env = EnvironmentEvo.getInstance();
//
// export default class ApiWebCallEvo extends ApiCall {
//     constructor(
//         serviceUrl: string,
//         params = {},
//         headers = {},
//         method: string = "POST"
//     ) {
//         let url = env.getEvoUrl() + serviceUrl;
//         super(url, params, headers, method);
//     }
//
//     public async getHeaders(): Promise<{ [key: string]: string }> {
//         let headers = await super.getHeaders() as { [key: string]: string }; // Cast or ensure correct type
//         headers["Content-Type"] = "application/json";
//         headers["Content-aa"] = "aa/json";
//         return headers;
//     }
// }

// const env = EnvironmentEvo.getInstance();

// process.env.BUILD_ENV, vychozi 'development'
const env = (process.env.BUILD_ENV as 'development' | 'testing' | 'production') || 'production';

const environment = EnvironmentEvo.getInstance(env);

export default class ApiWebCallEvo extends ApiCall {
    constructor(
        serviceUrl: string,
        params = {},
        headers = {},
        method: string = "POST"
    ) {
        const url = environment.getEvoUrl() + serviceUrl;
        super(url, params, headers, method);
    }

    public async getHeaders(): Promise<{ [key: string]: string }> {
        try {

            let headers: { [key: string]: string } = (await super.getHeaders()) || {};


            const API_AUTH_ENCODED = btoa(`${API_AUTH_USERNAME}:${API_AUTH_PASSWORD}`);

            headers["Authorization"] = "Basic " + API_AUTH_ENCODED;

            headers["Content-Type"] = "application/json";
            headers["Content-aa"] = "aa/json";


            // Add cookies
            const phpSessionId = Cookies.get("PHPSESSID");
            const netteBrowser = Cookies.get("nette-browser");

            if (phpSessionId) {
                headers["Cookie"] = `PHPSESSID=${phpSessionId}`;
            }

            if (netteBrowser) {
                // Append nette-browser to the existing Cookie header or create a new one
                headers["Cookie"] = headers["Cookie"]
                    ? `${headers["Cookie"]}; nette-browser=${netteBrowser}`
                    : `nette-browser=${netteBrowser}`;
            }



            return headers;
        } catch (error) {
            console.error("Error in getHeaders:", error);
            throw new Error("Failed to get headers");
        }
    }
}


